export const getTextEllipsis = (text: string, length: number) =>
  `${text.trim().slice(0, length)} ${text.length > length ? '...' : ''}`;
